import R from "ramda";
import { BOOTSTRAP_VENDORS } from "actions/bootstrap-actions";
import {
  FETCH_VENDORS,
  LOADING_START,
  LOADING_STOP,
  SELECT_VENDORS,
  DESELECT_VENDORS,
  ADD_VENDOR_RULES,
  ADD_VENDOR_RULES_LOADING,
  ADD_VENDOR_RULES_LOADING_STOP,
  START_ADD_VENDOR_RULES_MODE,
  END_ADD_VENDOR_RULES_MODE,
  SELECT_CATEGORY_FOR_RULE,
  DELETE_VENDOR_RULE,
  ORDER_VENDORS,
  START_MERGE_VENDORS_MODE,
  END_MERGE_VENDORS_MODE,
  SELECT_MERGE_VENDOR,
  MERGE_VENDORS,
  MERGE_VENDORS_LOADING_START,
  MERGE_VENDORS_LOADING_STOP
} from "actions/vendors-actions";

export const initialState = {
  isAddVendorRulesLoading: false,
  isAddVendorRulesMode: false,
  isLoading: true,
  isMergeVendorsLoading: false,
  isMergeVendorsMode: false,
  orderBy: "name",
  orderDirection: "ASC",
  selectedCategory: null,
  selectedVendorIds: [],
  selectedVendor: null,
  vendors: []
};

export const vendorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_VENDORS:
    case MERGE_VENDORS:
      return R.merge(state, { vendors: action.data.vendors });
    case LOADING_START:
      return R.merge(state, { isLoading: true });
    case LOADING_STOP:
      return R.merge(state, { isLoading: false });
    case FETCH_VENDORS:
      return R.merge(state, { vendors: action.data.newVendors, isLoading: false });
    case SELECT_VENDORS:
      return stateForSelectVendors(state, action.data.vendorIds);
    case DESELECT_VENDORS:
      return stateForDeselectVendors(state, action.data.vendorIds);
    case ADD_VENDOR_RULES:
      return stateForAddVendorRules(state, action);
    case ADD_VENDOR_RULES_LOADING:
      return R.merge(state, { isAddVendorRulesLoading: true });
    case ADD_VENDOR_RULES_LOADING_STOP:
      return R.merge(state, { isAddVendorRulesLoading: false });
    case START_ADD_VENDOR_RULES_MODE:
      return R.merge(state, { isAddVendorRulesMode: true });
    case END_ADD_VENDOR_RULES_MODE:
      return R.merge(state, { isAddVendorRulesMode: false });
    case SELECT_CATEGORY_FOR_RULE:
      return R.merge(state, { selectedCategory: action.data.category });
    case DELETE_VENDOR_RULE:
      return stateForDeleteVendorRule(state, action);
    case ORDER_VENDORS:
      return stateForOrderVendors(state, action);
    case START_MERGE_VENDORS_MODE:
      return R.merge(state, { isMergeVendorsMode: true });
    case END_MERGE_VENDORS_MODE:
      return R.merge(state, { isMergeVendorsMode: false });
    case SELECT_MERGE_VENDOR:
      return R.merge(state, { selectedVendor: action.data.vendor });
    case MERGE_VENDORS_LOADING_START:
      return R.merge(state, { isMergeVendorsLoading: true });
    case MERGE_VENDORS_LOADING_STOP:
      return stateForMergeVendorsLoadingStop(state);
    default:
      return state;
  }
};

const stateForSelectVendors = (state, vendorIds) => {
  let vendorIdsArray = vendorIds;
  if (typeof vendorIds === "string") {
    vendorIdsArray = [vendorIds];
  }
  if (typeof vendorIds === "object" && vendorIds.id) {
    vendorIdsArray = [vendorIds.id];
  }
  const currentIds = state.selectedVendorIds;
  const newIds = vendorIdsArray.filter(id => !currentIds.includes(id));
  const appendedIds = R.append(newIds, currentIds);
  return R.merge(state, { selectedVendorIds: R.flatten(appendedIds) });
};

const stateForDeselectVendors = (state, vendorIds) => {
  const currentIds = state.selectedVendorIds;
  const newIds = currentIds.filter(id => !vendorIds.includes(id));
  return R.merge(state, { selectedVendorIds: newIds });
};

const stateForAddVendorRules = (state, action) => {
  const category = R.find(R.propEq("id", action.data.category.info))(action.data.categories);
  const newVendors = state.vendors.map((vendor) => {
    if (action.data.vendors.indexOf(vendor.name) > -1) {
      const newIncludeRules = R.append(action.data.vendorRule, vendor.rules.includeVendors);
      const newCategory = R.set(R.lensPath(["rules", "includeVendors"]), newIncludeRules, category);
      return R.set(R.lensProp("rules"), R.append(newCategory, vendor.rules), vendor);
    }
    return vendor;
  });
  return R.merge(state, { vendors: newVendors });
};

const stateForDeleteVendorRule = (state, action) => {
  const index = R.findIndex(R.propEq("name", action.data.vendor.vendorName))(state.vendors);
  const vendor = R.find(R.propEq("name", action.data.vendor.vendorName))(state.vendors);
  const newRules = R.reject(R.propEq("id", action.data.category.id), vendor.rules);
  const newVendor = R.set(R.lensProp("rules"), newRules, vendor);
  const newVendors = R.update(index, newVendor, state.vendors);
  return R.merge(state, { vendors: newVendors });
};

const stateForOrderVendors = (state, action) => {
  const column = action.data.column;
  switch (action.data.column) {
    case "name":
      return orderBy(state, column, (a, b) => b[column].localeCompare(a[column]));
    case "receipts":
      return orderBy(state, column, (a, b) => b[column] - a[column]);
    case "rules":
      return orderBy(state, column, (a, b) => b[column].length - a[column].length);
    default:
      return state.vendors;
  }
};

const orderBy = (state, column, sortFunction) => {
  if (state.orderDirection === "ASC") {
    return R.merge(state, {
      orderBy: column,
      orderDirection: "DSC",
      vendors: R.sort(sortFunction, state.vendors)
    });
  }
  return R.merge(state, {
    orderBy: column,
    orderDirection: "ASC",
    vendors: R.reverse(R.sort(sortFunction, state.vendors))
  });
};

const stateForMergeVendorsLoadingStop = (state) => (
  R.merge(state, {
    isMergeVendorsLoading: false,
    isMergeVendorsMode: false,
    selectedVendor: null,
    selectedVendorIds: []
  })
);



// WEBPACK FOOTER //
// ./src/js/reducers/vendors-reducer.js